import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/components/document-title";
import { SessionDetailPage } from "@/features/charging-sessions/pages/session-detail-page/session-detail-page";

export const Route = createFileRoute(
	"/_authenticated/admin/charging/sessions/$sessionId"
)({
	head: () => pageTitle("Charging session"),
	component: SessionDetailPage,
});
